/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br."Knowledge
 * for Decisions (K4D)" and the slogan"Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { StatusPage, Title } from'@/shared/ui';
import { useTranslation } from"react-i18next";
import { PageSEO } from"@/shared/seo";
import { useGlobalError } from"@context/ErrorContext";
import { useNavigate } from'react-router';
import { formatErrorTitle, formatErrorMessage } from"@/shared/ui/components/basic/error-notification/report-error";

const ErrorPage: React.FC = () => {
  const { t } = useTranslation("@pages/error");
  const { globalError } = useGlobalError((state) => state);
  const navigate = useNavigate();
  const status_code = globalError?.code || globalError?.status;
  const status_text = globalError?.statusText;

  return (
    <>
      <PageSEO title={t("pageTitle")} />
      <Title order={1} className="sr-only text-h1 font-bold">{t("pageTitle")}</Title>
      <StatusPage
        code={status_code}
        title={status_text || (globalError ? formatErrorTitle(globalError) : t("title"))}
        titleClassName="text-[var(--seed-base)]"
        description={globalError ? formatErrorMessage(globalError) : t("description")}
        actionLabel={t("goHome")}
        onAction={() => navigate('/')}
      />
    </>
  );
};

export default ErrorPage;
